export default __webpack_public_path__ + "images/0x2fc5cf65fd0a660801f119832b2158756968266d.png";